import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { BlogModule } from '../blog/blog.module';
import { BlogItemComponent } from '../blog/blog-item/blog-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { IvyCarouselModule } from 'angular-responsive-carousel';
@NgModule({
  declarations: [
    HomeComponent,
    // BlogItemComponent
  ],
  imports: [
    CommonModule,
    BlogModule,
    RouterModule,
    IvyCarouselModule,
    TranslateModule.forChild()
  ]
})
export class HomeModule { }
